<h4>Getting Started</h4>
<p>
    Aliquam sagittis rhoncus vulputate. Cras non luctus sem, sed tincidunt ligula. Vestibulum at nunc elit. Praesent aliquet ligula mi, in luctus elit volutpat porta. Phasellus molestie diam vel nisi sodales, a eleifend augue laoreet.
    Sed nec eleifend justo. Nam et sollicitudin odio.
</p>
<figure>
    <img src="https://bulma.io/images/placeholders/256x256.png">
    <figcaption><small> Figure 1: Some beautiful placeholders </small></figcaption>
</figure>
<dl>
    <dt>Description lists</dt>
    <dd>A description list is perfect for defining terms.</dd>
    <dt>Euismod</dt>
    <dd>Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.</dd>
    <dd>Donec id elit non mi porta gravida at eget metus.</dd>
    <dt>Malesuada porta</dt>
    <dd>Etiam porta sem malesuada magna mollis euismod.</dd>
</dl>
<table class="table">
    <thead>
        <tr>
            <th> One </th>
            <th> Two </th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td> Three </td>
            <td> Four </td>
        </tr>
        <tr>
            <td> Five </td>
            <td> Six </td>
        </tr>
        <tr>
            <td> Seven </td>
            <td> Eight </td>
        </tr>
        <tr>
            <td> Nine </td>
            <td> Ten </td>
        </tr>
        <tr>
            <td> Eleven </td>
            <td> Twelve </td>
        </tr>
    </tbody>
</table>
